import { useTranslation } from 'react-i18next';
import gridIcon from '@/assets/images/gridFillRoundedSmall.svg';
import listIcon from '@/assets/images/listFillRoundedSmall.svg';
import { useMenuView } from '@/context/MenuViewContext/MenuViewContext';
import styles from './ViewSwitcher.module.scss';

const ViewSwitcher = () => {
  const {
    state: { isGrid },
    toggleView,
  } = useMenuView();
  const { t } = useTranslation();

  return (
    <div className={styles.viewSwitcher} data-testid="view-switcher">
      <button
        className={`${styles.toggleButton} ${isGrid ? styles.active : ''}`}
        onClick={toggleView}
        aria-label={
          isGrid ? t('viewSwitcher.switchToListView') : t('viewSwitcher.switchToGridView')
        }
        data-testid="view-switcher-button"
      >
        <div className={styles.toggleTrack}>
          <div
            className={`${styles.toggleSegment} ${styles.gridSegment} ${isGrid ? styles.active : ''}`}
          >
            <img src={gridIcon} alt={t('viewSwitcher.gridView')} className={styles.icon} />
          </div>
          <div
            className={`${styles.toggleSegment} ${styles.listSegment} ${!isGrid ? styles.active : ''}`}
          >
            <img src={listIcon} alt={t('viewSwitcher.listView')} className={styles.icon} />
          </div>
        </div>
      </button>
    </div>
  );
};

export default ViewSwitcher;
